import React, { useEffect, useState, useContext } from 'react';
import { Image, Spin } from 'antd';
import { SummaryCard, TotalSummaryCard } from '../../common/SummaryCard';
import { useBusinessContext } from '../../context/BusinessContext';
import { useConnection } from '@sezenta/connection';
import { IReportSummary } from '../../dto/SummaryReport';

export const Dashboard: React.FC = () => {
  const { businessId } = useBusinessContext();
  const { get } = useConnection();
  const [summaryData, setSummaryData] = useState<IReportSummary>();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSummary = async () => {
      if (!businessId) return;
      try {
        const data = await get(`/businesses/${businessId}/dashboard-summary`);
        setSummaryData(data?.data);
      } catch (error) {
        console.error('Failed to fetch summary data', error);
      } finally {
        setLoading(false);
      }
    };

    fetchSummary();
  }, [businessId, get]);

  return (
    <div className="w-full h-full p-5 ctable">
      <h1 className="text-xs mb-2 text-gray-400">Dashboard</h1>
      <div className="font-inter font-semibold text-[24px] leading-[32px] tracking-[-1.9%] text-[#000000]">
        Summary
      </div>

      <Spin spinning={loading}>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
          {/*<SummaryCard*/}
          {/*  icon={<Image src="/img/svg/file.svg" preview={false} />}*/}
          {/*  title="Reports"*/}
          {/*  value={summaryData?.count?.total ?? 0}*/}
          {/*/>*/}
          <SummaryCard
            icon={<Image src="/img/d2.png" preview={false} />}
            title="Active Stores"
            value={summaryData?.sites ?? 0}
          />
          <SummaryCard
            icon={
              <Image src="/img/d3.png" preview={false} width={80} height={80} />
            }
            title="Drivers"
            value={summaryData?.drivers ?? 0}
          />
        </div>

        <div className="text-[20px] leading-[32px] tracking-[1.9px] font-medium font-[Inter] text-[#000000] mb-4">
          Today&#39;s Collection Summary
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 m-0">
          {/*<TotalSummaryCard*/}
          {/*  title="Today Collection"*/}
          {/*  value="$12,426"*/}
          {/*  percentage={0}*/}
          {/*  isPositive*/}
          {/*/>*/}
          <TotalSummaryCard
            title="Total Weight (kg)"
            value={summaryData?.weight?.today ?? 0}
            percentage={summaryData?.weight?.change?.value ?? 0}
            isPositive={summaryData?.weight?.change?.isPositive ?? false}
          />
          <TotalSummaryCard
            title="Total No of Bags"
            value={summaryData?.bags?.today ?? 0}
            percentage={summaryData?.bags?.change?.value ?? 0}
            isPositive={summaryData?.bags?.change?.isPositive ?? false}
          />
          <TotalSummaryCard
            title={'Total No of Reports'}
            value={summaryData?.count?.today ?? 0}
            percentage={summaryData?.count?.change?.value ?? 0}
            isPositive={summaryData?.count?.change?.isPositive ?? false}
          />
        </div>

        <div className="text-[20px] leading-[32px] tracking-[1.9px] font-medium font-[Inter] text-[#000000] mb-4 mt-10">
          Total Collection Summary
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 m-0">
          {/*<TotalSummaryCard*/}
          {/*  title="Today Collection"*/}
          {/*  value="$12,426"*/}
          {/*  percentage={0}*/}
          {/*  isPositive*/}
          {/*/>*/}
          <TotalSummaryCard
            title="Total Weight (kg)"
            value={summaryData?.weight?.total ?? 0}
            isTotal={true}
          />
          <TotalSummaryCard
            title="Total No of Bags"
            value={summaryData?.bags?.total ?? 0}
            isTotal={true}
          />
          <TotalSummaryCard
            title={'Total No of Reports'}
            value={summaryData?.count?.total ?? 0}
            isTotal={true}
          />
        </div>
      </Spin>
    </div>
  );
};
